/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import { AppBar, Toolbar, IconButton, Menu, MenuItem } from "@mui/material";
import "./AppHeader.css";
import HomeIcon from "@mui/icons-material/HomeOutlined";
import PeopleIcon from "@mui/icons-material/PeopleOutlineOutlined";
import ListItemIcon from "@mui/material/ListItemIcon";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import AccountIcon from "@mui/icons-material/AccountCircleOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { useLocation, useNavigate } from "react-router";
import { ClientApi } from "../../../API/ClientApi";
import { TickerData } from "../../../@Types/ComponentsInterface/TickerDataResponse";
import Tooltip from "@mui/material/Tooltip";
import { normalizeRole } from "../../../utils/normalizeRole";
const Header: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [userRole, setUserRole] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [isHovered, setIsHovered] = useState(false);
  const tickerRef = useRef<HTMLDivElement | null>(null);

  const handleLogout = () => {
    localStorage.removeItem("useraData");
    localStorage.removeItem("access_token");
    navigate("/");
  };

  const isMenuItemActive = (menuItem: string) => {
    return location.pathname === menuItem ? "active" : "";
  };

  const navigateToTeamAndSpocs = () => {
    navigate("/teamAndSpocs");
  };
  const navigateToRiderKyc = () => {
    navigate("/riderKyc");
  };
  
  const navigateTomanagestore = () => {
    navigate("/managestore");
  };
  const navigateToHome = () => {
    navigate("/Dashboard");
  };
  
  const navigateToProfile = () => {
    navigate("/profile");
  };
  const merchantLogo = localStorage.getItem("merchantLogoUrl") || undefined;
  const merchantName = localStorage.getItem("merchantName") || undefined;
  const name = localStorage.getItem("name") || undefined;

  const [tickerData, setTickerData] = useState<any>();

  const ls = require("localstorage-ttl");
  const cachedTickerData = ls.get("tickerData");
  useEffect(() => {
    const role = normalizeRole(localStorage.getItem("userRole"));
    setUserRole(role);
  }, []);
  useEffect(() => {
   
    const fetchData = async () => {
      try {
        if (cachedTickerData) {
          setTickerData(JSON.parse(cachedTickerData));
        } else {
          const clientApi = new ClientApi();
          const token = localStorage.getItem("access_token");

          const tickerResponse = await clientApi.tickerData(token);
          setTickerData(tickerResponse.tickerData);
          ls.set(
            "tickerData",
            JSON.stringify(tickerResponse.tickerData),
            86400
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [cachedTickerData,ls]);

  const handleMouseEnter = () => {
    setIsHovered(true);
    if (tickerRef.current) {
      tickerRef.current.style.animationPlayState = "paused";
    }
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    if (tickerRef.current) {
      tickerRef.current.style.animationPlayState = "running";
    }
  };

 


  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const hiddenNotificationPaths = ["/riderKyc", "/riderdeatilkyc", "/alluserReport"];
  const renderMenuTabs = () => {
    if (userRole === "ROLE_OPERATION_SUPER_ADMIN") {
      return (
        <>
          <a
            onClick={navigateTomanagestore}
            className={`cursor-pointer ${isMenuItemActive("/managestore")} mr-2 ml-6`}
          >
            <PeopleIcon fontSize="small" className="mr-1 ml-2" /> Manage Store
          </a>
          <a
            onClick={() => navigate("/manageB2CClients")}
            className={`cursor-pointer ${isMenuItemActive("/manageB2CClients")} mr-2 ml-6`}
          >
            <PeopleIcon fontSize="small" className="mr-1 ml-2" /> Manage B2C Clients
          </a>
          {/* <a
            onClick={navigateCreateStore}
            className={`cursor-pointer ${isMenuItemActive("/createStore")} mr-2 ml-6`}
          >
            <PeopleIcon fontSize="small" className="mr-1 ml-2" /> Create Store
          </a>
          <a
            onClick={navigateAlluserReport}
            className={`cursor-pointer ${isMenuItemActive("/alluserReport")} mr-2 ml-6`}
          >
            <PeopleIcon fontSize="small" className="mr-1 ml-2" /> All User Report
          </a>
          <a
            onClick={navigateAllotedUserReport}
            className={`cursor-pointer ${isMenuItemActive("/allottedUserReport")} mr-2 ml-6`}
          >
            <PeopleIcon fontSize="small" className="mr-1 ml-2" /> Allotted User Report
          </a> */}
        </>
      );
    } else if (userRole === "ROLE_CLUSTER_MANAGER") {
      // Only show the Client Mapping tab
      return (
        <>
          <a
            onClick={navigateToRiderKyc}
            className={`cursor-pointer ${isMenuItemActive("/riderKyc")} mr-2 ml-6`}
          >
            <PeopleIcon fontSize="small" className="mr-1 ml-2" /> Client Mapping
          </a>
        </>
      );
    }
    else if (userRole === "ROLE_FLEET_SUPER_ADMIN") {
      return (
        <a
          onClick={() => navigate("/scooter-owner")}
          className={`cursor-pointer ${isMenuItemActive("/scooter-owner")} mr-4 ml-6 inline-flex items-center text-[15px]`}
        >
          <PeopleIcon fontSize="medium" className="mr-1.5 ml-2" /> Scooter Owner
        </a>
      );
    }
    else if (userRole === "ROLE_OPERATION_SUPER_ADMIN_LOADER") {
      // Show the Manage B2C Clients tab
      return (
        <>
         <a
            onClick={() => navigate("/manageB2CClients")}
            className={`cursor-pointer ${isMenuItemActive("/manageB2CClients")} mr-2 ml-6`}
          >
            <PeopleIcon fontSize="small" className="mr-1 ml-2" /> Manage B2C Clients
          </a>
        </>
      );
    }
     else {
      // Default tabs for all other roles
      return (
        <>
          <a
            onClick={navigateToHome}
            className={`cursor-pointer ${isMenuItemActive("/Dashboard")} mr-2 ml-6`}
          >
            <HomeIcon fontSize="small" className="mr-1 ml-2" /> Home
          </a>
          <a
            onClick={navigateToTeamAndSpocs}
            className={`cursor-pointer ${isMenuItemActive("/teamAndSpocs")} mr-2 ml-6`}
          >
            <PeopleIcon fontSize="small" className="mr-1 ml-2" /> Teams & Spocs
          </a>
          
        </>
      );
    }
  };
  
  return (
    <div className="w-full text-sm text-[#455A64] font-rubik font-semibold">
      <AppBar
        position="sticky"
        className="bg-gradient-to-r from-slate-100 to-50"
        style={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #EBEBEB",
          boxShadow: "0px 4px 30px 4px #00000005",
        }}
      >
        <Toolbar className="justify-between">
      
          <div className="flex items-center ">
            <img
              src={"/assets/icons/invoice-logo.svg"}
              alt="Logo"
              className="h-8 mr-4"
            />
  {!hiddenNotificationPaths.includes(location.pathname) && userRole !== "ROLE_OPERATION_SUPER_ADMIN" && (
            <img src={merchantLogo} alt="Logo" className="h-8" />
          )}
          </div>
     
          {/* Scrolling Marquee for News Ticker */}
          <div
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              cursor: isHovered ? "default" : "pointer",
              marginLeft: "120px",
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className="flex items-center"
          >
            <div
              ref={tickerRef}
              style={{
                animation: "marquee 20s linear infinite",
                width: "100%",
                color: "black",
              }}
            >
              {tickerData?.map((data: TickerData, index: number) => (
                <span key={index} className="pr-6">
                  {data.url ? (
                    <>
                      <a href={data.url} target="_blank" rel="noreferrer">
                        {data.heading}
                      </a>
                      {index !== tickerData.length - 1 && (
                        <span className="pl-6 text-lg">|</span>
                      )}
                    </>
                  ) : (
                    <>
                      <span>{data.heading}</span>
                      {index !== tickerData.length - 1 && (
                        <span className="pl-6 text-lg">|</span>
                      )}
                    </>
                  )}
                </span>
              ))}
            </div>
          </div>

          <div className="flex items-center w-2/5 justify-end">
            
            {location.pathname !== "/" && (
              <div className="flex  items-center justify-end">
                <Tooltip title="Account">
                  <IconButton
                    onClick={handleClick}
                    size="small"
                    aria-controls={open ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                  >
                    <AccountCircleOutlinedIcon
                      color="success"
                      fontSize="large"
                    />
                  </IconButton>
                </Tooltip>
                {/* Menu */}
                <Menu
                  anchorEl={anchorEl}
                  id="account-menu"
                  open={open}
                  onClose={handleClose}
                  onClick={handleClose}
                >
                  <MenuItem onClick={navigateToProfile}>
                    <ListItemIcon>
                      <AccountIcon fontSize="small" />
                    </ListItemIcon>
                    Profile
                  </MenuItem>
                 
                  {!hiddenNotificationPaths.includes(location.pathname) && userRole !== "ROLE_OPERATION_SUPER_ADMIN" && (
                  <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                      <Settings fontSize="small" />
                    </ListItemIcon>
                    Settings
                  </MenuItem>
                    )}
                   
                  <MenuItem onClick={handleLogout}>
                    <ListItemIcon>
                      <Logout fontSize="small" />
                    </ListItemIcon>
                    Logout
                  </MenuItem>
                </Menu>
                {!hiddenNotificationPaths.includes(location.pathname) && (
                <p className="text-black">
                      {userRole === "ROLE_OPERATION_SUPER_ADMIN" || userRole === "ROLE_FLEET_SUPER_ADMIN"
                        ? name
                        : merchantName}

                  </p>
                )}
              </div>
            )}
          </div>
        </Toolbar>
      </AppBar>
      {/* Space for the menu content */}
      <div
        className="h-30 "
        style={{ backgroundColor: "#FFFFFF", border: "0px solid #EBEBEB" }}
      >
        <AppBar position="static" color="inherit">
          <Toolbar className="p-4">
           
          {renderMenuTabs()}

          </Toolbar>
        </AppBar>
      </div>
    </div>
  );
};

export default Header;
